module.exports = new __parcel__URL__("compass.9f623f39.svg").toString();